export const isTransferAnswer = clientAnswer => {
  return clientAnswer?._type === 'V4/Transfer' && clientAnswer?.transferStatus
}

export const isPaymentAnswer = clientAnswer => {
  return clientAnswer?._type === 'V4/Payment' && clientAnswer?.orderStatus
}

export const isTransactionCycleClosed = clientAnswer => {
  const cycleKey = isTransferAnswer(clientAnswer)
    ? 'transferCycle'
    : 'orderCycle'

  return clientAnswer[cycleKey] === 'CLOSED'
}

export const isTransactionCardCycleClosed = clientAnswer => {
  if (isTransferAnswer(clientAnswer)) {
    return isTransactionCycleClosed(clientAnswer)
  }

  return clientAnswer?.cardOrderCycle === 'CLOSED'
}

export const isTransactionStatusUnpaid = clientAnswer => {
  const status = clientAnswer?.transactions[0]?.status.toUpperCase()

  return (
    status === 'UNPAID' ||
    (!!isTransferAnswer(clientAnswer) && status === 'UNTRANSFERRED')
  )
}

export const isTransactionStatusAccepted = clientAnswer => {
  const status = clientAnswer?.transactions[0]?.status.toUpperCase()

  if (isTransferAnswer(clientAnswer)) {
    return ~['TRANSFERRED', 'RUNNING'].indexOf(status)
  } else {
    return ~['PAID', 'RUNNING'].indexOf(status)
  }
}

export const getStatus = clientAnswer => {
  const detailKey = isTransferAnswer(clientAnswer)
    ? 'transferStatus'
    : 'orderStatus'

  return clientAnswer?.[detailKey]
}

export const getDetails = clientAnswer => {
  const detailKey = isTransferAnswer(clientAnswer)
    ? 'transferDetails'
    : 'orderDetails'

  return clientAnswer?.[detailKey]
}
